import * as actions from './actions';

const initialState = {}; // new InitialState;

export default function manageConsentsReducer(state = initialState, action) {
  switch (action.type) {

    case actions.FETCH_MANAGE_CONSENTS_START: {
      return Object.assign({}, state, {
        isFetching: true,
        errorMessage: '',
      });
    }

    case actions.FETCH_MANAGE_CONSENTS_SUCCESS: {
      return Object.assign({}, action.payload, state, {
        isFetching: false,
        errorMessage: '',
      });
    }

    case actions.FETCH_MANAGE_CONSENTS_ERROR: {
      return Object.assign({}, state, {
        isFetching: false,
        errorMessage: action.payload.message,
      });
    }
    
    default: {
      return state;
    }
  }
}
